import type { ElementRef } from '@angular/core';
import {
  Component,
  computed,
  forwardRef,
  input,
  model,
  viewChild,
} from '@angular/core';
import type { FormValueControl } from '@angular/forms/signals';
import { ONYX_FOCUSABLE } from '../../../directives/onyx-auto-focus.directive';
import { OnyxBaseFormControlComponent } from '../../../internal/components/onyx-base-form-control/onyx-base-form-control.component';
import { OnyxInputLabelComponent } from '../../labels/onyx-input-label/onyx-input-label.component';

@Component({
  selector: 'onyx-radio-button',
  imports: [OnyxInputLabelComponent],
  templateUrl: './onyx-radio-button.component.html',
  styleUrls: ['./onyx-radio-button.component.scss'],
  host: {
    '(click)': `updateValue($event)`,
    '(keydown.space)': `updateValue($event)`,
  },
  providers: [
    {
      provide: ONYX_FOCUSABLE,
      useExisting: forwardRef(() => OnyxRadioButtonComponent),
    },
  ],
})
export class OnyxRadioButtonComponent<T>
  extends OnyxBaseFormControlComponent
  implements FormValueControl<T | null>
{
  public readonly value = model<T | null>(null);
  public readonly option = input.required<T>();
  public readonly label = input<string>();
  public readonly size = input<16 | 24>(16);

  private readonly radioElementRef =
    viewChild.required<ElementRef<HTMLElement>>('radioElement');

  protected active = computed(() => this.value() === this.option());

  public focus(): void {
    if (this.disabled()) return;

    this.radioElementRef().nativeElement.focus();
  }

  protected updateValue(event: Event): void {
    if (this.disabled()) return;

    this.value.set(this.option());
    this.touch.emit();
    event.preventDefault();
  }
}
